const YOUTUBE_CHANNEL_URL =
  'https://www.youtube.com/channel/UCrQRPj9ITYeUw0N65yDkfSA';
const ELEVAT_DOCUMENTATION_URL =
  'https://elevat.atlassian.net/wiki/spaces/ED/overview';
const REMOTE_ACCESS_GUIDE_URL =
  'https://elevatstorageprod.blob.core.windows.net/documentation/Elevat%20Remote%20Access%20Guide.pdf';
const REMOTE_ACCESS_WINDOWS_INSTALLER_URL =
  'https://elevatstorageprod.blob.core.windows.net/documentation/Elevat%20Remote%20Access.latest.exe';

export {
  YOUTUBE_CHANNEL_URL,
  ELEVAT_DOCUMENTATION_URL,
  REMOTE_ACCESS_GUIDE_URL,
  REMOTE_ACCESS_WINDOWS_INSTALLER_URL,
};
